export const formatCPF = (cpf: string): string => {
    let digits = cpf.replace(/\D/g, "");

    digits = digits.padStart(11, "0");

    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}